import { faPlusSquare } from '@fortawesome/free-regular-svg-icons'
import type { FC } from 'react'
import React from 'react'

import ActionButton from './ActionButton'

interface Props {
  onClick: () => void
}

const AddButton: FC<Props> = ({ onClick }) => (
  <ActionButton label="Add" icon={faPlusSquare} onClick={onClick} />
)

export default AddButton
